import { wireScheduleDateGenerator } from "#/admin/schedule_date_generator/lib/wire-trigger";

wireScheduleDateGenerator();
